const isSafari = require('../utils/isSafari');

module.exports = event => (isSafari ? event.target.scrollTop : event.path[0].scrollTop);
